import { render, staticRenderFns } from "./resume-list-editor.vue?vue&type=template&id=39ce538b&lang=pug&"
import script from "./resume-list-editor.vue?vue&type=script&lang=js&"
export * from "./resume-list-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports